import { logError } from '@utils/errorLogging';
import { domToBlob } from 'modern-screenshot';

/** Marker class on the feedback drawer root so the panel never appears in its own screenshot. */
export const FEEDBACK_UI_EXCLUDE_CLASS = 'feedback-ui-exclude';

const MAX_SCREENSHOT_BYTES = 5_000_000;
// iframes (chat widget, etc.) match tag name; everything else matches the exclude selector.
const EXCLUDED_SELECTOR = `.${FEEDBACK_UI_EXCLUDE_CLASS}, [data-feedback-ui='true']`;

const toFile = (blob: Blob) =>
  new File([blob], `feedback-${Date.now()}.jpg`, { type: 'image/jpeg' });

const capture = (quality: number) =>
  domToBlob(document.body, {
    type: 'image/jpeg',
    quality,
    backgroundColor: '#ffffff',
    // Font embedding walks every stylesheet and downloads each font file; not worth the CPU for a bug-report thumbnail.
    font: false,
    filter: (node) =>
      !(
        node instanceof Element &&
        (node.tagName === 'IFRAME' || node.matches(EXCLUDED_SELECTOR))
      ),
  });

export const captureScreenshot = async (): Promise<File | undefined> => {
  try {
    let blob = await capture(0.8);

    // Long pages can exceed the server limit; one lower-quality retry before giving up.
    if (blob.size > MAX_SCREENSHOT_BYTES) {
      blob = await capture(0.5);
    }

    return blob.size > MAX_SCREENSHOT_BYTES ? undefined : toFile(blob);
  } catch (error) {
    logError('captureFeedbackScreenshot', error as Error);
    return undefined;
  }
};
